<template>
    <div class="dingdan">
        <breadcrumb v-if="firstPageFlag!=1" :routerList="[{to:'/dingd/myOrderList',title:'订单管理'},{title:'订单列表'}]"/>
        <div class="h-piece h-mrt30 margin">
            <div class="h-formBox">
                <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
                    <el-form-item label="客户名称">
                        <el-input v-model="formInline.cunameLike" placeholder="请输入" style="width: 1.3rem"></el-input>
                        <!--                        <el-select v-model="formInline.cucode"-->
                        <!--                                   placeholder="请选择" clearable>-->
                        <!--                            <el-option v-for="item in tableData"-->
                        <!--                                       :label="item.cuname"-->
                        <!--                                       :value="item.cucode">-->
                        <!--                                {{ item.cuname }}-->
                        <!--                            </el-option>-->
                        <!--                        </el-select>-->
                    </el-form-item>

                    <el-form-item label="销售组织">
                        <brselect category="xiaoshou_zuzhi" :v="formInline.saleGroupCode"
                                  v-model="formInline.saleGroupCode" style="width:2rem" clearable></brselect>
                    </el-form-item>
                    <el-form-item label="订单类型">
                        <el-select v-model="formInline.orderCategory" style="width:1.5rem" clearable>
                            <el-option label="内销订单" value="1"></el-option>
                            <el-option label="外销订单" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="订单状态">
                        <brselect style="width:2rem" clearable category="dingdan_zhuangtai" :v="formInline.orderStatus"
                                  v-model="formInline.orderStatus"></brselect>

                    </el-form-item>

                    <el-form-item class="h-formBtnOut" style="margin-right: 0">
                        <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                        <el-button class="h-btn h-formBtn" @click="resetData"
                                   style="background-color:white;color:black;border:1px solid #d1d1d1">重置
                        </el-button>

                        <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" style="width:1.6rem;"
                                   @click="create" v-if="firstPageFlag!=1">
                            新建订单
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div> 
        <div class="h-table h-mrt30 " v-if="clickActive==1">
            <el-table
                ref="multipleTable"
                @selection-change="handleSelectionChange"
                :data="tableData"
                class="SorH"
                stripe
				border
                style="width: 100%"
            >
                <el-table-column
                    type="selection"
                    width="60"
                    :label="all"
                >
                </el-table-column>
                <el-table-column
                    fixed
                    type="index"
                    label="#"
                    width="40">
                </el-table-column>
                <el-table-column
                    prop="sapCode0"
                    label="订单编号"
                    width="140">
                </el-table-column>
                <el-table-column
                        prop="cuname"
                        label="客户名称"
						:show-overflow-tooltip="true"
                        width="230">
                </el-table-column>
                <el-table-column
                        prop="saleGroupCode"
                        label="销售组织"
						:show-overflow-tooltip="true"
                        width="250">
                    <template slot-scope="scope">
                        <dictname category="xiaoshou_zuzhi" :v="scope.row.saleGroupCode"/>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="toAddress"
                        label="收货单位名称"
						:show-overflow-tooltip="true"
                        width="350">
                </el-table-column>
                <el-table-column
                    prop="contactName"
                    label="联系人"
                    width="90"
                    :show-overflow-tooltip="true"
                    >
                </el-table-column>
                <el-table-column
                    prop="orderCategory"
                    label="订单类型"
                    width="130"
                    >
                    <template slot-scope="scope">
                        <dictname category="xiaoshou_quyu"  :v="scope.row.orderCategory"/>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="materialCode0"
                    label="产品编码"
                    width="130">
                </el-table-column>
                <el-table-column
                        prop="proModelCode0"
                        label="产品型号"
                        width="170">
                </el-table-column>
                <el-table-column
                        prop="receivedTime"
                        label="预计收货日期"
						:show-overflow-tooltip="true"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="isStockUp"
                        label="是否备货"
                        width="90">
                    <template slot-scope="scope">
                        <dictname category="shifou_keyong"  :v="scope.row.isStockUp"/>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="orderStatus"
                        label="订单状态"
                        width="130">
                    <template slot-scope="scope">
                        <dictname category="dingdan_zhuangtai"  :v="scope.row.orderStatus"/>
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="150">
                    <template slot-scope="scope">
                        <el-button
                                size="small" class="h-tableLink h-btn"
                                @click="goDetails(scope.row.oid)">
                            查看
                        </el-button>
                        <el-button
                                size="small" class="h-tableLink h-btn"
                                @click="genzongLiuch(scope.row)">
                            跟踪
                        </el-button>
                        <el-button
                                type="text" size="small" class="h-tableLink h-btn"
                                @click="deleteByIdLogi(scope.row)">
                            删除
                        </el-button>
						<!-- <div class="l-operationBox">
							<span class="l-operationlist br-operation-look" title="查看" @click="goDetails(scope.row.oid)"></span>
							<span class="l-operationlist br-operation-spgz" title="跟踪审批" @click="genzongLiuch(scope.row)"></span>
							<span class="l-operationlist br-operation-delete" title="删除" @click="deleteByIdLogi(scope.row)"></span>
						</div> -->
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="h-tableB h-mrt30">
            <div class="h-tableBL">
                <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="downloadExcel">
                    批量导出
                </el-button>
                <!--                <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export">批量导入</el-button>-->
            </div>
            <div class="h-pagination2">
                <pagination :page="q" @query="query"/>
            </div>
        </div>

        <!--创建订单弹出框-->
        <div class="D-date">
            <el-dialog :visible.sync="dialogFormVisible" class="h-dialog2">
                <div class="h-dialogImg">
                    <div class="h-disTable">
                        <div class="h-tableCell">
                            <h1>新建订单信息</h1>
                        </div>
                    </div>
                </div>
                <div class="h-formLine">
                    <el-form ref="form" :model="b" :inline="true" class="demo-ruleForm h-formbLine h-dialogForm">
                        <el-form-item label="订单类型" class="h-elformWrap-2">
                            <el-cascader
                                    :options="orderTypeOptions"
                                    v-model="selectedOptions"
                                    :props="{
                                        value: 'code',
                                        label: 'name',
                                    }"
                                    @change="handleOrderChange">
                            </el-cascader>
                        </el-form-item>
                        <el-form-item label="项目名称" class="h-elformWrap-2" v-show="xiangmuTab">
                            <el-select v-model="b.id"
                                       placeholder="请选择" clearable @change="getProjectName">
                                <el-option v-for="item in allProjectByUser"
                                           :key="item.id"
                                           :label="item.projectName"
                                           :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="销售组织" class="h-elformWrap-2">

                            <el-select v-model="b.saleGroupCode" @change="$forceUpdate()">
                                <el-option v-for="item in xszz"
                                           :key="item.code"
                                           :label="item.name"
                                           :value="item.code"/>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="分销渠道" class="h-elformWrap-2">

                            <el-cascader style="width:100%;"
                                         :options="fxqd"
                                         v-model="b.disChannelCode"
                                         @change="handleChange"
                                         :props="{
                                        value: 'code',
                                        label: 'name',
                                    }">
                            </el-cascader>

                        </el-form-item>
                    </el-form>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button class="h-btn h-formBtn h-bgwhite" @click="cancel">取消</el-button>
                    <el-button class="h-btn h-formBtn h-bgblueQ2" @click="saveTo">确定</el-button>
                </div>
            </el-dialog>
        </div>
        <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
    </div>
</template>
<script>
    import ss from '../../api/SystemService'
    import updownfile from '../../utils/updownfile';

    export default {
        props: ["firstPageFlag"],
        data() {
            return {
              
                instid: null,
                //根据用户id查询出的所有项目
                allProjectByUser: [],

                orderTypeOptions: [],

                //分销渠道
                options: [],
                selectedOptions: [],

                //销售组织
                allxszz: [],
                xszz: [],
                //分销渠道
                allfxqd: [],
                fxqd: [],

                sapDel: {
                    id: '',
                    deleteReason: '',
                },
                dialogFormVisible: false,
                //表单
                q: {
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                    cucode: '',
                    orderType: '',
                    orderCategory: '',
                    ids: [],
                    saleGroupCode: '',
                    orderStatus: '',

                },
                //创建订单表单
                b: {
                    customerId: '',
                    bjdId: '',
                    poId: '',
                    goFlag: false,
                    orderCategory1: '',
                    orderCategory: '',
                    saleGroupCode: '',
                    disChannelCode: '',
                    zCode: '',
                    id: '',
                    projectName: '',
                    projectId: '',
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                all: '全部',
                formInline: {},
                //表格
                multipleSelection: [],
                tableData: [],
                xiangmuTab: false,
                clickActive: 1,

                // flags: {
                //     flag1: false,
                //     flag2: false,
                //     flag3: false,
                //     flag4: false,
                //     flag5: false,
                //     flag6: true,
                //     flag7: true,
                // },
                handleSizeChange: '',
                handleCurrentChange: '',
            }
        },

        created() {
            this.query();
            this.orderTypeOptions = this.$store.getters.dictlist("xiaoshou_quyu");
            _.find(this.orderTypeOptions, {code: '1'}).children = this.$store.getters.dictlist("xiaoshou_quyu_nx");
            _.find(this.orderTypeOptions, {code: '2'}).children = this.$store.getters.dictlist("xiaoshou_quyu_wx");

            this.options = this.$store.getters.dictlist("fenxiao_qudao");
            _.find(this.options, {code: 'Z1'}).children = this.$store.getters.dictlist("fenxiao_qudao_shanghai");

            this.allxszz = this.$store.getters.dictlist('YLSalesOrganization_agent');
            this.allfxqd = this.$store.getters.dictlist('fenxiao_qudao');
        },


        methods: {
            onMouseOver(){
                this.seen = true
            },
            onMouseOut(){
                this.seen = false
            },
            genzongLiuch(r) {
                console.log(r);
                this.instid = r.instid;
                this.showhistory = true;
            },
            //订单类型改变后方法
            handleOrderChange(value) {
                this.b.saleGroupCode = null
                this.b.disChannelCode = null
                this.b.orderCategory = value[0];
                this.b.orderCategory1 = value[1] || '';
                this.projectManagePage(this.b.orderCategory1);
                this.xiangmuTab = false;
                // this.flags.flag1 = this.flags.flag2 = this.flags.flag3 = this.flags.flag4 = false;
                // this.flags.flag5 = this.flags.flag6 = this.flags.flag7 = false;
                //内销
                if (value[0] == '1') {
                    // this.flags.flag2 = true;
                    // this.flags.flag3 = true;
                    // this.flags.flag5 = true;
                    // this.b.saleGroupCode = '9370';

                    //销售组织
                    this.xszz = _.filter(this.allxszz, (o) => {
                        return _.includes(['9390', '9370'], o.code);
                    })
                    this.b.saleGroupCode = '9390'
                    // 项目
                    if (value[1] == '1' || value[1] == '7' || value[1] == '8') {
                        this.xiangmuTab = true;
                    }
                    //分销渠道
                    this.b.disChannelCode = '00';
                    this.fxqd = _.filter(this.allfxqd, {code: '00'})
                    //外销
                } else if (value[0] == 2) {
                    // this.flags.flag1 = true;
                    // this.flags.flag3 = true;
                    // this.flags.flag6 = true;
                    //项目
                    this.xiangmuTab = true;
                    //销售组织
                    this.xszz = _.filter(this.allxszz, (o) => {
                        return _.includes(['6200', '9390'], o.code);
                    })
                    this.b.saleGroupCode = '9390'
                    //分销渠道
                    this.b.disChannelCode = '00';
                    this.fxqd = _.filter(this.allfxqd, {code: '00'})

                } else if (value[0] == 3) {
                    //    上海直销
                    // this.flags.flag4 = true;
                    // this.flags.flag7 = true;
                    this.xszz = _.filter(this.allxszz, (o) => {
                        return _.includes(['9391'], o.code);
                    })
                    this.b.disChannelCode = 'Z1';
                    this.fxqd = _.filter(this.allfxqd, {code: 'Z1'})
                    this.fxqd.children = this.$store.getters.dictlist('fenxiao_qudao_shanghai');
                }

            },

            //选中id后把项目名称赋值
            getProjectName(x) {
                let item = _.find(this.allProjectByUser, {id: x});
                console.log(item)
                this.b.projectName = item.projectName;
                this.b.poId = item.poId;
                this.b.bjdId = item.bjdId;
                this.b.customerId = item.customerId;
            },

            //分销渠道改变后方法
            handleChange(value) {
                this.b.disChannelCode = value[0];
                this.b.zCode = value[1] || '';
            },
            //获取当前用户所有项目详情
            projectManagePage(x) {
                ss.OrderService.projectManagePage1(x).then(rd => {
                    this.allProjectByUser = rd;
                });
            },
            //创建订单弹窗方法
            saveTo() {
                var ddlx = this.b.orderCategory
                var ddzlx = this.b.orderCategory1
                this.dialogFormVisible = false;
                this.b.id = this.b.id || ''
                this.b.projectName = this.b.projectName || ''
                if (ddlx == '1') {
                    // 内销
                    //售后订单
                    if (ddzlx == '4') {
                        this.$router.push({path: "/dingd/createShouhouOrder", query: this.b})
                        return;
                    } else if (ddzlx == '9') {
                        //服务订单
                        this.$router.push({path: "/dingd/material/fuwu", query: this.b})
                        return;
                    }
                    this.$router.push({path: "/dingd/createNewOrder", query: this.b})
                } else if (ddlx == '2') {
                    //外销
                    this.$router.push({path: "/dingd/waixiao", query: this.b})
                    return;
                } else {
                    //上海直销

                }
            },
            cancel() {
                this.dialogFormVisible = false;
                this.tableData2 = [];
                this.q.orderType = '',
                    this.q.orderCategory = '',
                    this.q.saleGroupCode = '',
                    this.selectedOptions = [];
            },

            //查看详情跳转
            goDetails(x) {
                this.$router.push({path: "/dingd/myOrderDetails", query: {orderId: x}})
            },
            //勾选事件
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            //查询该用户及所有子用户所有订单详情
            query() {
                this.q.orderCategory = this.formInline.orderCategory;
                this.q.orderType = this.formInline.orderType;
                this.q.cucode = this.formInline.cucode;
                this.q.cunameLike = this.formInline.cunameLike;
                this.q.saleGroupCode = this.formInline.saleGroupCode;
                this.q.orderStatus = this.formInline.orderStatus;

                ss.OrderService.getAllOrderProByUserIdPage(this.q).then(rd => {
                    this.tableData = rd.records;
                    this.q.total = rd.total;
                });
            },

            //检索
            handleFilter() {
                this.q.pageNo = 1;
                this.query();
            },

            //查询该用户所有订单详情
            querySingle() {
                ss.OrderService.getOrderProByUserIdPage(this.q).then(rd => {
                    this.tableData = rd.records;
                    this.q.total = rd.total;
                });
            },

            //逻辑删除某条产品
            deleteByIdLogi(x) {
                this.$msg.confirm("确认删除?", () => {
                    this.sapDel.id = x.pid;
                    this.sapDel.deleteReason = x.delReason;
                    ss.OrderService.sapDeleteOrder(this.sapDel).then(rd => {
                        console.log('删除结果:' + rd)
                        this.query();
                    });
                })

            },
            // 重置按钮
            resetData() {
                this.formInline.cucode = ""
                this.formInline.cunameLike = ""
                this.formInline.orderType = ""
                this.formInline.orderCategory = ""
                this.formInline.saleGroupCode = ""
                this.formInline.orderStatus = ""
                this.q.pageSize = 10;
                this.query();
            },
            //导出Excel
            downloadExcel() {
                var idlist = [];
                this.multipleSelection.forEach(element => {
                    idlist.push(element.pid);
                });
                if (idlist.length < 1) {
                    this.$msg.msge('请先勾选需要导出的数据!');
                    return;
                }

                this.q.ids = idlist;
                this.q.orderCategory = this.formInline.orderCategory;
                this.q.orderType = this.formInline.orderType;
                this.q.cucode = this.formInline.cucode;
                this.q.cunameLike = this.formInline.cunameLike;
                this.q.saleGroupCode = this.formInline.saleGroupCode;
                this.q.orderStatus = this.formInline.orderStatus;

                updownfile.down("/api/swyl/v1/bsc/order/getOrderExcel?ids=" + this.q.ids, this.q.ids, "get", "data");

            },
            //创建订单框
            create() {
                this.selectedOptions = [];
                this.b = {};
                this.dialogFormVisible = true;
                //this.q = {};
            },
        },

        mounted() {
        },

    }
</script>
<style scoped>
    .xiangmu .h-piece, .h-mrt30 {
        margin: 20px;
    }

    .h-formBtnOut .h-mr20 {
        margin-left: 1rem !important;
    }

    .D-date .el-cascader {
        line-height: 0;
    }

</style>
<style>
  
</style>



